/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const LogQueryKeys = {
  all: ['user'] as const,
  lists: () => [...LogQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...LogQueryKeys.lists(), { filters }] as const,
  details: () => [...LogQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...LogQueryKeys.details(), id] as const,
};
